import { ProductModalFormValue } from './index';
import { AppRoutes } from 'routes/routeConstants/appRoutes';
import { generatePath } from 'react-router-dom';
import { Product } from 'models/Product/product.model';
import { MetaData } from 'models/MetaData/metaData.model';
import { RcFile } from 'antd/lib/upload';
import { ProductCreationUpdationType } from 'services/ProductsService/productCreation.service';

export const handleFormSubmission = async (
    values: ProductModalFormValue,
    {
        isNewProduct,
        newProduct,
        products,
        updateProduct,
        createProduct,
        uploadProductImage,
        callbackAfterSubmit,
        handleModalCancel,
        navigate,
        image,
        handleOpenValidationModal,
    }: {
        isNewProduct: boolean;
        newProduct?: Product;
        products: MetaData[];
        updateProduct: (data: ProductCreationUpdationType) => Promise<void>;
        createProduct: (data: ProductCreationUpdationType) => Promise<number>;
        uploadProductImage: (productId: string, fileObj: RcFile, isCommodity?: boolean) => Promise<void>;
        callbackAfterSubmit?: () => void;
        handleModalCancel: () => void;
        navigate: (path: string, options?: { replace: boolean }) => void;
        image?: File;
        handleOpenValidationModal: (errorCode?: string) => void;
    }
) => {
    const productName =
        !isNewProduct && newProduct?.name ? newProduct.name : values.productName;
    const parentProduct = products?.find(item => item.name === productName);
    const data = {
        id: values?.id,
        name: productName,
        description: values.description,
        brand_id: values.brand,
        net_weight: Number(values.productNetWeight),
        net_weight_unit: values.ml,
        gross_weight: Number(values.productGrossWeight),
        temperature_control: values.temperatureControl,
        density: Number(values.productDensity),
        processing_facility_id: values.processingFacility,
        reporting_period_units: Number(values.reportingPeriodProduction),
        reporting_year: values.reportingYear,
        processing_facility_cost_percentage: Number(
            values.percentageProcessingFacilityCostGood
        ),
        unique_id: parentProduct?.uniqueId ?? null,
    };

    if (values.id) {
        updateProduct(data)
            .then(async () => {
                if (image && typeof image === 'object') {
                    await uploadProductImage(values.id, image as RcFile);
                }
                await callbackAfterSubmit?.();

                handleModalCancel();
                navigate(
                    generatePath(
                        `${AppRoutes.CREATE_PRODUCT}/${AppRoutes.CREATE_PRODUCT_RAW_MATERIAL}`,
                        { id: values.id }
                    ),
                    {
                        replace: true,
                    }
                );
            })
            .catch(errorCode => handleOpenValidationModal(errorCode));
    } else {
        await createProduct(data)
            .then(async productId => {
                if (image) {
                    await uploadProductImage(productId.toString(), image as RcFile);
                }

                navigate(
                    generatePath(
                        `${AppRoutes.CREATE_PRODUCT}/${AppRoutes.CREATE_PRODUCT_RAW_MATERIAL}`,
                        { id: productId }
                    )
                );
            })
            .catch(errorCode => {
                handleOpenValidationModal(errorCode);
            });
    }
};